module.exports = __webpack_public_path__ + "static/img/1.f570ae7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/1.png
// module id = boSs
// module chunks = 0